import { Car, Palette, Eye, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import featureFlags from '../config/featureFlags';

// Services configuration - Shop-related service is only shown when shop is enabled
const getServices = () => {
  const services = [];
  
  // Only include shop service if enabled
  if (featureFlags.SHOP_ENABLED) {
    services.push({
      icon: Car,
      title: "Individuelle Plot-Aufkleber",
      price: "ab 11,90 €*",
      priceNote: "*Mindestbestellwert pro Motiv",
      description: "Professionell geplottete, einfarbige Folienaufkleber nach Wunschmaß. Ideal für Logos, Schriftzüge und klare Designs – präzise zugeschnitten und montagefertig geliefert.",
      cta: "Jetzt konfigurieren",
      ctaAction: "shop",
      color: "bg-teal-50 text-teal-600"
    });
  }
  
  services.push(
    {
      icon: Palette,
      title: "Logo-Erstellung",
      price: "ab 149 €",
      priceNote: "",
      description: "Individuelle Logo-Entwicklung für Unternehmen, Marken und Projekte. Modern, durchdacht und einsatzbereit für Print, Werbetechnik und digitale Medien.",
      cta: "Logo anfragen",
      ctaAction: "contact",
      color: "bg-slate-100 text-slate-700"
    },
    {
      icon: Eye,
      title: "Mockups / Fahrzeug-Design Vorschau",
      price: "ab 79 €",
      priceNote: "Dienstleistung",
      description: "Realistische Design-Vorschau deines Projekts auf Fahrzeugen oder Werbeflächen. Perfekt zur Visualisierung vor Produktion und Druck.",
      cta: "Vorschau anfragen",
      ctaAction: "contact",
      color: "bg-teal-50 text-teal-600"
    }
  );
  
  return services;
};

export const Services = () => {
  const scrollToContact = () => {
    const element = document.querySelector('#kontakt');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
  };

  return (
    <section
      id="leistungen"
      className="py-24 lg:py-32 bg-white noise-bg"
      data-testid="services-section"
    >
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 bg-teal-50 text-teal-700 text-sm font-semibold rounded-full mb-4">
            UNSERE LEISTUNGEN
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 tracking-tight mb-4">
            Design & Produktion
          </h2>
          <p className="text-lg text-slate-600 max-w-2xl mx-auto">
            Von der Idee zum druckfertigen Design – wir liefern versandfertige Lösungen.
          </p>
        </div>

        {/* Services Grid */}
        <div className={`grid grid-cols-1 ${getServices().length === 2 ? 'md:grid-cols-2 max-w-4xl mx-auto' : 'md:grid-cols-3'} gap-8`}>
          {getServices().map((service, index) => (
            <div
              key={index}
              className="group bg-white border border-slate-100 rounded-2xl p-8 card-hover"
              data-testid={`service-card-${index}`}
            >
              {/* Icon */}
              <div className={`w-14 h-14 rounded-xl ${service.color} flex items-center justify-center mb-6 transition-transform group-hover:scale-110`}>
                <service.icon className="w-7 h-7" />
              </div>

              {/* Title & Price */}
              <h3 className="text-xl font-bold text-slate-900 mb-2">
                {service.title}
              </h3>
              <div className="mb-4">
                <span className="text-2xl font-bold text-teal-600">{service.price}</span>
                {service.priceNote && (
                  <span className="block text-xs text-slate-500 mt-1">{service.priceNote}</span>
                )}
              </div>
              
              {/* Description */}
              <p className="text-slate-600 mb-6 leading-relaxed text-sm">
                {service.description}
              </p>

              {/* CTA */}
              <Button
                onClick={() => {
                  if (service.ctaAction === 'shop') {
                    const el = document.querySelector('#sticker');
                    if (el) el.scrollIntoView({ behavior: 'smooth' });
                  } else {
                    scrollToContact();
                  }
                }}
                className={`w-full rounded-full ${
                  service.ctaAction === 'shop' 
                    ? 'bg-teal-600 hover:bg-teal-700 text-white' 
                    : 'bg-slate-100 hover:bg-slate-200 text-slate-700'
                }`}
                data-testid={`service-cta-${index}`}
              >
                {service.cta}
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
